// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3WOsR","left":"StickyBox_left__2OgjA","right":"StickyBox_right__14hVc"};